<template>
  <Layout>
    <div class="banner-page">
      <img src="img/banner/berita-banner.png" alt="Image" />
    </div>

    <div class="breadcrumbs">
      <div class="container">
        <ul>
          <li>
            <a href="/">Beranda</a>
          </li>
          <li>
            <span>Berita</span>
          </li>
        </ul>
      </div>
    </div>

    <section class="page-section">
      <div class="berita-slider mb-40">
        <carousel
          :autoplay="true"
          :loop="true"
          :nav="false"
          :margin="16"
          :startPosition="1"
          :responsive="responsive"
        >
          <div class="item" v-for="slide in dataSlides" :key="slide.id">
            <div class="berita-slider-wrapper">
              <img :src="slide.url" alt="Image" />
            </div>
          </div>
        </carousel>
      </div>

      <div class="container">
        <div class="section-title text-center">Berita</div>
        <div class="berita-container" v-if="isLoaded">
          <!-- September 2022 -->
          <div
            class="berita-wrapper"
            v-for="data in databeritaSorted"
            :key="data.id"
          >
            <div class="berita-tanggal">
              {{ dateFormatBerita(data.start_date, data.end_date) }}
            </div>
            <a href="#" class="berita-item link-block">
              <div class="berita-tile">
                {{ data.title }}
              </div>
              <div v-html="data.desc"></div>
              <div class="row">
                <div
                  class="col-6 mt-3"
                  v-for="values in data.image"
                  :key="values.id"
                >
                  <img
                    :src="data.urlimage + values.path"
                    alt="Image"
                    style="border-radius: 10px"
                  />
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </section>

    <section class="page-section kalender-section bg-grey">
      <div class="container">
        <div class="section-title text-center color-main">
          Kalender Kegiatan
        </div>
        <FullCalendar :options="calendarOptions" />
        <p class="mt-16 mb-0">
          * Sewaktu-waktu Jadwal kegiatan mungkin bisa berubah
        </p>
      </div>
    </section>
  </Layout>
</template>

<script>
import '@fullcalendar/core/vdom'; // solves problem with Vite
import FullCalendar from '@fullcalendar/vue';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';

import Layout from '../views/layouts/Index.vue';

import carousel from 'vue-owl-carousel';

import { mapActions } from 'vuex';

import ModelBerita from '../views/data/data';

import axios from '../utils/api';

import moment from 'moment';

export default {
  components: {
    FullCalendar,
    Layout,
    carousel,
  },
  data() {
    return {
      calendarOptions: {
        locale: 'id',
        plugins: [dayGridPlugin, interactionPlugin],
        initialView: 'dayGridMonth',
        headerToolbar: {
          left: 'prevYear,prev,next,nextYear today',
          center: 'title',
          right: 'dayGridMonth,dayGridWeek,dayGridDay',
        },
        week: {
          dow: 0, // Monday is the first day of the week.
          doy: 7, // The week that contains Jan 1st is the first week of the year.
        },
        buttonText: {
          prev: 'Sebelumnya',
          next: 'Selanjutnya',
          today: 'Hari Ini',
          month: 'Bulan',
          week: 'Minggu',
          day: 'Hari',
          list: 'Agenda',
        },
        weekText: 'Minggu',
        allDayText: 'Sehari penuh',
        moreLinkText: 'Lebih',
        noEventsText: 'Tidak ada acara untuk ditampilkan',
      },
      responsive: {
        0: {
          stagePadding: 36,
          margin: 8,
          items: 2,
        },
        600: {
          stagePadding: 36,
          items: 4,
        },
        1140: {
          stagePadding: 80,
          items: 6,
        },
      },
      allBerita: [],
      isLoaded: false,
      ...ModelBerita,
    };
  },
  methods: {
    ...mapActions('transactions', ['resetForm']),
    async fetchBerita() {
      this.allBerita = await axios.get(
        `/berita?kodelembaga=MASJED&type=berita`
      );

      this.isLoaded = true;
    },
    dateFormatBerita(start_date, end_date) {
      let startDate = new Date(start_date);
      let endDate = new Date(end_date);

      if (start_date !== end_date) {
        return (
          moment(startDate).format('DD ') +
          moment(endDate).format('- DD MMMM YYYY')
        );
      }

      return moment(startDate).format('DD MMMM YYYY');
    },
  },
  mounted() {
    this.fetchBerita();
    this.resetForm();
  },
  computed: {
    databeritaSorted() {
      return this.allBerita.data.data.sort(function (a, b) {
        return b.id - a.id;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.yaitu {
  margin: 0px !important;
  padding: 0px !important;
  padding-left: 15px !important;
  li {
    font-size: 12px;
    margin: 0px !important;
    padding: 0px !important;
  }
}
</style>
